import React from "react";
import { Typography } from "@mui/material";
import "./mentions_legales.css";
import 'bootstrap/dist/css/bootstrap.min.css';


function Mentions_legales() {

  return (
    <div className="div-mentions-legales">
      <section className="bg-section-mention-legales">
       
        <img src="" alt=""/>
        <Typography
                variant="h4"
                style={{
                  color: "#4AAE9B",
                  textAlign: "left",
                  fontFamily: "Majetto",
                  fontSize: "2.5vw",
                  fontStyle: "normal",
                  fontWeight: 400,
                  
                  marginBottom: "50px",
                }}
              >
                Mentions Légales
              </Typography>

              <p> <b>Éditeur du site</b><br></br>

Société : YANACOM SARL<br></br>

Adresse : BP80427 66334 Cabestany CEDEX<br></br>

Tel : 06 35 52 57 32<br></br>
Site internet : http://www.yanacom.fr<br></br>
Email : contact@yanacom.fr<br></br></p>

<p><b>Création et réalisation du site</b><br></br>

YANACOM SARL<br></br>
232 Rue A. Beau de Rochas 66000 PERPIGNAN FRANCE<br></br>
www.yanacom.fr<br></br></p>

<p><b>Hébergement : OVH</b>

Société OVH<br></br>
Siège social : 2 rue Kellermann - 59100 Roubaix, France<br></br>
Tél: +33 (0)8 99 70 17 61<br></br>
Site web : www.ovh.com<br></br></p>

<p><b>Conditions d’utilisation</b><br></br>

Le site accessible par l'url suivant : www.yanacom.fr est exploité dans le respect de la législation française.
L’utilisation de ce site est régie par les présentes conditions générales. En utilisant le site, 
vous reconnaissez avoir pris connaissance de ces conditions et les avoir acceptées.
 Celles-ci pourront êtres modifiées à tout moment et sans préavis par la société YANACOM. 
 YANACOM ne saurait être tenu pour responsable en aucune manière d’une mauvaise utilisation du service.</p>

 <p><b>Responsabilité</b><br></br>

Aucune autre garantie n’est accordée au client, auquel incombe l’obligation de formuler clairement ses besoins et le devoir de s’informer.
Si des informations fournies par YANACOM apparaissent inexactes, il appartiendra au client de procéder lui-même à toutes vérifications de 
la cohérence ou de la vraisemblance des résultats obtenus. YANACOM ne sera en aucune façon responsable vis à vis des tiers de l’utilisation par le
 client des informations ou de leur absence contenues dans ses services y compris un de ses sites Internet.</p>

      </section>
      
    </div>





  );
}

export default Mentions_legales;
